const SCOPE_ALL = 'all'
const SCOPE_WILDCARD = '*'

type Parsed = {
  // "domain::resource::action" without #scope
  base: string
  // "all" if no # present
  scope: string
  hasExplicitScope: boolean
}

export function parse(perm: string): Parsed {
  const hashIdx = perm.indexOf('#')
  if (hashIdx < 0) {
    return { base: perm, scope: SCOPE_ALL, hasExplicitScope: false }
  }
  return {
    base: perm.slice(0, hashIdx),
    scope: perm.slice(hashIdx + 1),
    hasExplicitScope: true,
  }
}

/**
 * Reports whether a single grant satisfies a single check.
 *
 * Scope semantics (mirroring the backend):
 * - A grant with no scope (bare) or `#all` matches any scope check, including `#*`.
 * - A check with no scope (or `#all`) only matches grants that are bare or explicitly `#all`.
 * - A check with `#*` matches any grant of the same domain/resource/action.
 * - Otherwise both scopes must match exactly.
 */
export function check(grant: string, want: string): boolean {
  const g = parse(grant)
  const c = parse(want)
  if (g.base !== c.base) {
    return false
  }
  if (g.scope === SCOPE_ALL) {
    return true
  }
  if (c.scope === SCOPE_WILDCARD) {
    return true
  }
  if (c.scope === SCOPE_ALL) {
    return false
  }
  return g.scope === c.scope
}

/**
 * Reports whether any grant in the list satisfies the check.
 */
export function hasPermission(
  grants: readonly string[],
  want: string,
): boolean {
  return grants.some((g) => check(g, want))
}
